module.exports = __webpack_public_path__ + "static/media/t8.01a769b0.jpg";